module.exports = __webpack_public_path__ + "img/3.e843607d.png";